import { StyleSheet } from 'react-native';

import { mediaQueryValues } from '../media-query';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    marginLeft: mediaQuery.extraSmall,
  },
});
